module.exports = __webpack_public_path__ + "img/logo_min.7d249c8b.png";